<template>
    <div class="ui-label">
        <the-btn
            :text="text"
            class="btn btn-block btn-secondary px-3 py-1"
            :class="{ 'no-hover': !hoverable }"
            @click.native="$emit('click')"
        ></the-btn>
    </div>
</template>

<script>
export default {
    name: 'UiLabel',
    props: {
        hoverable: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.ui-label {
    .btn {
        font-size: 0.7rem;
        border-radius: 1rem;
    }
    .no-hover {
        pointer-events: none;
    }
}
</style>
